module.exports = __webpack_public_path__ + "img/nora_big.f18c3b.png";